<template>
    <div class="update-password box">
        <div class="box-title">
            Update Password
        </div>
        <div class="box-content">
            <form
                id="password-reset"
                novalidate
                @submit.prevent="validate"
            >
                <div class="field flex">
                    <span class="field-title">Current password</span>
                    <div class="input">
                        <fieldset
                            :class="{ error: passwordErrorMessage }"
                        >
                            <input
                                v-model="password.current"
                                type="password"
                                name="current-password"
                                autocomplete="off"
                                :class="{ error: passwordErrorMessage }"
                                @click="clearError()"
                            >
                            <span
                                v-if="passwordErrorMessage"
                                class="form-error"
                            >
                                {{ passwordErrorMessage }}
                            </span>
                        </fieldset>
                    </div>
                </div>
                <div class="field flex">
                    <span class="field-title">New Password</span>
                    <div class="input">
                        <fieldset
                            :class="{ error: newPasswordErrorMessage }"
                        >
                            <input
                                v-model="password.password"
                                type="password"
                                name="password"
                                autocomplete="off"
                                :class="{ error: newPasswordErrorMessage }"
                                @click="clearError()"
                            >
                            <span
                                v-if="newPasswordErrorMessage"
                                class="form-error"
                            >
                                {{ newPasswordErrorMessage }}
                            </span>
                        </fieldset>
                    </div>
                </div>
                <div class="field flex">
                    <span class="field-title">Confirm Password</span>
                    <div class="input">
                        <fieldset
                            :class="{ error: password_confirmationErrorMessage }"
                        >
                            <input
                                v-model="password.password_confirmation"
                                type="password"
                                name="password-confirmation"
                                autocomplete="off"
                                :class="{ error: password_confirmationErrorMessage }"
                                @click="clearError()"
                            >
                            <span
                                v-if="password_confirmationErrorMessage"
                                class="form-error"
                            >
                                {{ password_confirmationErrorMessage }}
                            </span>
                        </fieldset>
                    </div>
                </div>
                <div class="controll-container flex">
                    <base-form-button
                        class="btn"
                        :loading="formProcessing"
                    >
                        Save Changes
                    </base-form-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { passwordValidator } from '@/utils/form/validation.js';
import apiCall from '@/utils/apiCall';

import toasts from '@/mixins/toasts';

export default {
    mixins: [toasts],

    data: () => ({
        password: {
            current: null,
            password: null,
            password_confirmation: '',
        },
        passwordErrorMessage: null,
        newPasswordErrorMessage: null,
        password_confirmationErrorMessage: null,
        formProcessing: false,
    }),

    methods: {
        /**
         * Clears errors
         *
         */
        clearError() {
            this.passwordErrorMessage = null;
            this.newPasswordErrorMessage = null;
            this.password_confirmationErrorMessage = null;
        },

        /**
         * Validates user passwords
         *
         */
        validate() {
            const { current, password, password_confirmation } = this.password;

            if (! current) {
                this.passwordErrorMessage = 'Please enter current password';
                return;
            }

            const { validation, type, message } = passwordValidator(password, password_confirmation);

            if (! validation) {
                if (! type) {
                    this.newPasswordErrorMessage = message;
                } else {
                    this.newPasswordErrorMessage = message;
                    this.password_confirmationErrorMessage = message;
                }

                return;
            }

            this.send();
        },

        /**
         * Validates user passwords
         *
         */
        async send() {
            const { status, data } = await apiCall(this, 'put', '/api/user/password-update', { ...this.password });

            if (200 === status) {
                this.toastSuccess({
                    message: {
                        title: 'Your password has been changed!',
                    },
                });

                return;
            }

            if (422 === status) {
                const { errors, message } = data;

                if (errors.password) {
                    this.newPasswordErrorMessage = errors.password[0] ?? message;
                }

                if (errors.current) {
                    this.passwordErrorMessage = errors.current[0] ?? message;
                }

                return;
            }

            if (401 === status) {
                this.passwordErrorMessage = data.message;
            }
        },
    },
};
</script>
